import React, { useState, useEffect, useCallback, useRef } from 'react';
import { Link, useParams } from 'react-router-dom';
import renderHTML from 'react-render-html';
import ReactPlayer from 'react-player'
import Moment from 'moment';
// import cookie from 'react-cookies'
import axios from 'axios';

import {API_URL,BASE_URL_RECURSOS} from '../../constants';
import {loadingPrincipal} from '../../functions';

// import Coments from '../extras/comentarios';
import RateStar from '../extras/valoracion';

Moment.updateLocale('en', {
  months : [
    "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio",
    "Agosto", "Setiembre", "Octubre", "Noviembre", "Diciembre"
  ]
});
Moment.updateLocale('en', {
  weekdays : [
    "Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"
  ]
});


const ResourceDetail = props => {

 

  const security = props.security;
  const [user, setUser] = useState(props.user);
  const [tipo, setTipo] = useState(props.tipo);
  // Get data from path
  /* Url is static so there is no need to use useRef */
  const nBoletinCodigo = useParams().boletin;
  const urlCanonical = useParams().title;
  const nRecursoCodigo = useRef(0);

  // Component states
  const [resource, setResource] = useState(false);
  const [news, setNews] = useState([]);

  const handleResourceResponse = data => {

    // Error 404 Not Found
    if(data.data.result.nRecursoCodigo===0){
      loadingPrincipal(false);  // Hide charging view
      // Redirect to 404 Resource Page
      props.notFound({message: "El recurso no fue encontrado"});
      return;
    }

    // Compare with bulletinCode
    /**/

    // Save nRecursoCodigo
    nRecursoCodigo.current = data.data.result.nRecursoCodigo;

    // Save gotten resource
    setResource(data.data.result);

    // Return in case url is id
    return data.data.result.sUrlCanonical
  }
  const bypassId = () => {
    // Get resource by id (urlCanonical)
    axios.get(
      `${API_URL}ResourceUX/${urlCanonical}/0/`,
      {
        headers: {
          'Content-Type': 'application/json; charset=UTF-8' ,
          'Accept': 'application/json'
        }
      }
    ).then(handleResourceResponse)
    .then(_urlCanonical => {
      if(_urlCanonical){  // If resource has urlCanonical
        // Change url to set urlCanonical
        if(window.history.pushState){  // Check if history.pushState
          let _tmp = document.location.pathname.split("/");
          _tmp[_tmp.length-1] = _urlCanonical;
          _tmp = _tmp.join("/");
          window.history.pushState({}, null, _tmp);
        }
      }
    }).catch(error => {
      console.log("Un error ha ocurrido");
      console.log(error);
    });
  }

  const getResourceByTitle = () => {
    // Check if url has id instead of urlCanonical
    if( !isNaN(urlCanonical) ){
      bypassId();
      return;
    }

    // Get resource by UrlCanonical
    axios.get(
      `${API_URL}ResourceUX/${urlCanonical}`,
      {
        headers: {
          'Content-Type': 'application/json; charset=UTF-8' ,
          'Accept': 'application/json'
        }
      }
    ).then(handleResourceResponse)
    .catch(error => {
      console.log("Un error ha ocurrido");
      console.log(error);
    });

    // Patch data
    var formData = JSON.stringify({ nRecursoCodigo: nRecursoCodigo.current, sKey: 'V'});
    axios.patch(
      `${API_URL}ResourceUX/`,
      JSON.stringify(formData),
      {
        headers: {
          'Content-Type': 'application/json; charset=UTF-8' ,
          'Accept': 'application/json'
        }
      }
    )
    .then(response => response.data)
    .then((data) => {})
    .catch(error => {});
  }

  // Run at first render
  useEffect(() => {
    getResourceByTitle();
  }, []);
  // Run when resource changes
  useEffect(() => {
    if(!resource) return;  // Abort if resource is false

    loadingPrincipal(false);  // Hide charging view
  }, [resource]);

  document.title=resource.sTitulo;

  return (
    resource && resource.hasOwnProperty("nRecursoCodigo")
    ? (
      <div className="main">
        <div className="l_section gray-bg-light">
          <div className="boletin__section">
            <div className="row boletin__subheader">
              <div className="col-sm-12" hidden={(tipo==="portal"?true:false)}>
                <i className="boletin__subheader--arrow fas fa-chevron-left"></i>
                <Link to={`/${nBoletinCodigo}/`}>
                  <span>BOLETÍN</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="l_section gray-bg-semilight boletin__category--mobile">
          <div className="boletin__section">
            <div className="row boletin__subheader">
              <div className="col-sm-12">
                <ul id="boletin__header-title">
                  <li className="boletin__category"><span className="boletin__category--pl"><strong>Boletín de inteligencia</strong></span></li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="boletin-resume gray-bg-full-light">
          <div className="boletin__section">
            <div className="row boletin-resume__row">
              <div className="col-sm-12">
              <h1 className="boletin-resume__title">{resource.sTitulo} </h1>
              </div>
              <div className="col-sm-12">
                <div className="boletin-resume__subtitle">
                <p className="boletin-resume__author">{resource.sAutor}</p>
                <p className="boletin-resume__date">{Moment(resource.dFechaPublicacion).format('DD/MM/YYYY')}</p>
                </div>
              </div>
              <div className="col-sm-12">
                <p className="boletin-resume__info">
                  {resource.sResumen}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="boletin-details gray-bg">
          <div className="boletin__section">
            <div className="row boletin__section__row">
              <div className="col-sm-9">
                <div>
                  <div>
                    <img
                      className="boletin-details__img" src={BASE_URL_RECURSOS+resource.sImagen} />
                  </div>
                  <p className="boletin-details__photo-description boletin-details__photo-description--main">
                    {resource.sTituloImagen}
                  </p>
                </div>
                {/* HTML Noticia */}
                <div className="boletin-details__statements">
                  {renderHTML('<span>' + (resource.sContenido===null?"":resource.sContenido) + '</span>')}
                  <center class="custom-div">
                    <ReactPlayer url={resource.sEnlaceVideo} playing={true} controls={true} />
                  </center>
                </div>
                {/* Bibliografía */}
                {/* <div className="boletin-details__bibliography">
                  <p className="boletin-details__bibliography-title">BIBLIOGRAFÍA</p>
                  <ul className="ul-without-bullets">
                    <li>
                      <span><i className="color-red fas fa-arrow-right"></i></span>
                      <span className="bibliography__reference">5 Reasons To Purchase Desktop Computers - <em>medium</em></span>
                    </li>
                    <li>
                      <span><i className="color-red fas fa-arrow-right"></i></span>
                      <span className="bibliography__reference">5 Reasons To Purchase Desktop Computers - <em>medium</em></span>
                    </li>
                    <li>
                      <span><i className="color-red fas fa-arrow-right"></i></span>
                      <span className="bibliography__reference">5 Reasons To Purchase Desktop Computers - <em>medium</em></span>
                    </li>
                    <li>
                      <span><i className="color-red fas fa-arrow-right"></i></span>
                      <span className="bibliography__reference">5 Reasons To Purchase Desktop Computers - <em>medium</em></span>
                    </li>
                  </ul>
                </div> */}
              </div>
              <div className="col-sm-3">
                <div className="row">
                  <div className="last-news-sector__secundary  col-sm-12">
                    <div className="boletin__rating">
                      <p className="boletin__rating-title">VALORA ESTA NOTICIA</p>
                      <RateStar clave={nRecursoCodigo.current} nRecursoCodigo={resource.nRecursoCodigo} />
                    </div>
                  </div>
                  {news.map((resource, index) => (
                    <div className="last-news-sector__secundary col-sm-12" key={resource.nRecursoCodigo}>
                      <div className="last-news-sector__secundary-item">
                        <p className="last-news__category">TENDENCIAS</p>
                        <p className="last-news-sector__secundary-item-title">
                          {resource.sTituloRecurso}
                        </p>
                        <p className="last-news-sector__secundary-item-extract">
                          {resource.sResumenRecurso}
                        </p>
                        <p className="last-news-sector__more-info">
                          <span className="last-news-sector__more-info-arrow"><i className="fas fa-chevron-right"></i></span>
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
          {/* <Coments></Coments> */}
        </div>
      </div>
    )
    : "Cargando..."
  );
}

export default ResourceDetail;
